/* eslint-disable @typescript-eslint/naming-convention */
import { AppTypeId } from '@ps/platform-message-framework/common/AppTypeId';
import { ProductId } from '@ps/platform-message-framework/common/ProductId';
import { select } from '@ps/web-core-store';
import { ApolloClientProvider } from '@ps/web-shared-components';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { GRAPHQL_API_PATHNAME } from '../utils/constants';

const ActiveGamesProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const { pokerApiDomain = '' } = useSelector(select.config.get);
  const site = useSelector(select.cms.getSiteId);
  const deviceId = useSelector(select.device.getId);
  const osId = useSelector(select.device.getOS);
  const brandId = useSelector(select.cms.getBrandId);
  const platformId = useSelector(select.device.getPlatform);
  const { idpToken, installId } = useSelector(select.session.get);
  const [headers, setHeaders] = useState({
    'X-FI-PS-SITE-ID': `${site}`,
    'X-FI-PS-DEVICE-ID': `${deviceId}`,
    'X-FI-PS-OS-ID': `${osId}`,
    'X-FI-PS-BRAND-ID': `${brandId}`,
    'X-FI-PS-INSTALL-ID': `${installId}`,
    'X-FI-PS-APP-TYPE-ID': `${AppTypeId.RAM}`,
    'X-FI-PS-PRODUCT-ID': `${ProductId.UNKNOWN}`,
    'X-FI-PS-PLATFORM-ID': `${platformId}`
  });

  useEffect(() => {
    setHeaders({
      'X-FI-PS-SITE-ID': `${site}`,
      'X-FI-PS-DEVICE-ID': `${deviceId}`,
      'X-FI-PS-OS-ID': `${osId}`,
      'X-FI-PS-BRAND-ID': `${brandId}`,
      'X-FI-PS-INSTALL-ID': `${installId}`,
      'X-FI-PS-APP-TYPE-ID': `${AppTypeId.RAM}`,
      'X-FI-PS-PRODUCT-ID': `${ProductId.UNKNOWN}`,
      'X-FI-PS-PLATFORM-ID': `${platformId}`
    });
  }, [site, deviceId, osId, brandId, installId, platformId]);

  if (!pokerApiDomain || !idpToken) return null;

  const wsUrl = new URL(pokerApiDomain);
  wsUrl.protocol = 'wss';
  wsUrl.pathname = GRAPHQL_API_PATHNAME;

  const httpUrl = new URL(pokerApiDomain);
  httpUrl.pathname = GRAPHQL_API_PATHNAME;

  return (
    <ApolloClientProvider
      idpToken={idpToken}
      httpLinkUri={httpUrl.href}
      wsLinkUrl={wsUrl.href}
      httpHeaders={headers}
      useIdpAuth
    >
      {children}
    </ApolloClientProvider>
  );
};

export default ActiveGamesProvider;
